var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.999,
    height: 49.999,
    viewBox: "0 0 49.999 49.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#da6c2e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.677,7.322A25,25,0,0,0,7.322,42.677,25,25,0,1,0,42.677,7.322ZM25,47.07A22.07,22.07,0,1,1,47.07,25,22.095,22.095,0,0,1,25,47.07Z",
    transform: "translate(0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.627 16.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M153.617,169.9a1.465,1.465,0,0,0-2.071,0L138.61,182.831l-6.809-6.809a1.465,1.465,0,1,0-2.072,2.072l7.845,7.845a1.465,1.465,0,0,0,2.071,0l13.971-13.971A1.465,1.465,0,0,0,153.617,169.9Z",
    transform: "translate(-129.301 -169.467)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.d8f30647f2bfd202ff3ce146052fb760.svg";
export { ForwardRef as ReactComponent };